import { db } from '../firebase';
import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  query, 
  where, 
  getDocs
} from 'firebase/firestore';

export const createAccount = async (userId, accountData) => {
  return await addDoc(collection(db, 'accounts'), {
    userId,
    ...accountData,
    createdAt: new Date()
  });
};

export const getAccounts = async (userId) => {
  const q = query(collection(db, 'accounts'), where('userId', '==', userId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const updateAccount = async (accountId, data) => {
  const accountRef = doc(db, 'accounts', accountId);
  return await updateDoc(accountRef, data);
};

export const deleteAccount = async (accountId) => {
  return await deleteDoc(doc(db, 'accounts', accountId));
};

export const updateAccountBalance = async (accountId, amount, type) => {
  const accountRef = doc(db, 'accounts', accountId);
  const accountSnap = await getDocs(query(collection(db, 'accounts'), where('__name__', '==', accountId)));
  
  if (!accountSnap.empty) {
    const currentBalance = accountSnap.docs[0].data().balance || 0;
    const newBalance = type === 'ingreso' 
      ? currentBalance + amount 
      : currentBalance - amount;
    
    return await updateDoc(accountRef, { balance: newBalance });
  }
};
